import { GET_USER_BUSINESS_ID } from "../../browser-db-config/localStorage";
import { HTTP_REQUEST } from "../../http-config/trac-http-req";

const state = {
  settlements: [],
  settlement: [],
  settlement_cummalations: [],
};

const getters = {
  GET_ALL_SETTLEMENTS: (state) => state.settlements,
  GET_SETTLEMENT: (state) => state.settlement,
  GET_ALL_CUMMULATIONS: (state) => state.settlement_cummalations,
};

const mutations = {
  SET_SETTLEMENTS_RES: (state, data) => {
    state.settlements = data;
  },
  SET_SETTLEMENT_RES: (state, data) => {
    state.settlement = data;
  },
  SET_SETTLEMENT_CUMMULATION_RES: (state, data) => {
    state.settlement_cummalations = data;
  },
};

const actions = {
  FETCH_SETTLEMENTS: async function (
    context,
    { startDate, endDate, page_size, status, page }
  ) {
    let url = `/v2/settlements/groups?page_size=${page_size}&status=${status}&page=${page}`;
    url += startDate ? `&start_date=${startDate}&end_date=${endDate}` : "";

    const httpReq = {
      url, //`?start_date=${startDate}&end_date=${endDate}&page_size=${page_size}&status=${status}`,
      method: "GET",
      authRequest: true,
    };

    const httpRes = await HTTP_REQUEST(httpReq);
    context.commit("SET_SETTLEMENTS_RES", httpRes);
    return httpRes;
  },
  FETCH_SETTLEMENT: async function (
    context,
    {
      group_id,
      page_size,
      searchFilter,
      search,
      dateFilter,
      date,
      isDownload,
      filter,
      status,
      page,
    }
  ) {
    let urlPath = `/v2/settlements/groups/${group_id}/cumulations?page_size=${page_size}&page=${page}`;

    urlPath += filter === "Status" ? `&status=${status}` : "";

    urlPath +=
      filter === "Date"
        ? `&start_date=${date.startDate} ${date.startTime}&end_date=${date.endDate} ${date.endTime}`
        : "";

    urlPath += filter === "Aggregator" ? `&is_aggregator=true` : "";

    urlPath += searchFilter ? `&search=${search}` : "";

    urlPath += isDownload ? `&is_download=true` : "";

    urlPath += dateFilter
      ? `&start_date=${date.startDate}&end_date=${date.endDate}`
      : "";

    const httpReq = {
      url: urlPath, //`/v2/settlements/groups/${group_id}/cumulations?page_size=${page_size}`,
      method: "GET",
      authRequest: true,
    };

    const httpRes = await HTTP_REQUEST(httpReq);
    context.commit("SET_SETTLEMENT_RES", httpRes);
    return httpRes;
  },

  FETCH_CUMMULATION_TRANSACTION: async function (context, { cummulation_id }) {
    const httpReq = {
      url: `/v2/settlements/cumulations/${cummulation_id}/transactions`,
      method: "GET",
      authRequest: true,
    };

    const httpRes = await HTTP_REQUEST(httpReq);
    context.commit("SET_SETTLEMENT_CUMMULATION_RES", httpRes);
    return httpRes;
  },
  MARK_AS_SETTLED: async function (context, { group_id, ids }) {
    const httpReq = {
      url: `/v2/settlements/groups/${group_id}/bulk-settlement`,
      method: "POST",
      body: {
        action: "manual-settle",
        cumulation_ids: ids,
        settle_alls: false,
      },
      authRequest: true,
    };

    const httpRes = await HTTP_REQUEST(httpReq);
    context.commit("SET_SETTLEMENT_CUMMULATION_RES", httpRes);
    return httpRes;
  },
  SETTLE_TRANSACTION: async function (context, { group_id, ids }) {
    const httpReq = {
      url: `/v2/settlements/groups/${group_id}/bulk-settlement`,
      method: "POST",
      body: {
        action: "actual-settle",
        cumulation_ids: ids,
        settle_alls: false,
      },
      authRequest: true,
    };

    const httpRes = await HTTP_REQUEST(httpReq);
    context.commit("SET_SETTLEMENT_CUMMULATION_RES", httpRes);
    return httpRes;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
